// "data:;base64,iVBORw0KGgo="" value prevents browser default favicon fetch if none present
export const DEFAULT_FAVICON = 'data:;base64,iVBORw0KGgo=';

export const PRECONNECT_YOUTUBE = [
	'https://www.youtube-nocookie.com',
	'https://i.ytimg.com',
	'https://www.google.com',
	'https://googleads.g.doubleclick.net',
	'https://static.doubleclick.net',
	'https://www.youtube.com',
	'https://youtube.com',
	'https://i9.ytimg.com',
	'https://s.ytimg.com',
];

export const PRECONNECT_VIMEO = [
	'https://vimeo.com',
	'https://i.vimeocdn.com',
	'https://f.vimeocdn.com',
	'https://player.vimeo.com',
];

export const PRECONNECT_MAP = [
	'https://www.google.com',
	'https://content-autofill.googleapis.com',
	'https://ktms1.googleapis.com',
	'https://maps.googleapis.com',
	'https://maps.gstatic.com',
];

export const PRECONNECT_INSTAGRAM = [
	'https://scontent-lga3-1.cdninstagram.com', // subdomain might be dynamic?
	'https://graph.instagram.com',
];

export const ZYROSITE_SUBDOMAINS = [
	'.zyrosite.space',
	'.zyrosite.com',
];

export const BUILDER_SUBDOMAINS = [
	'.hostinger.com',
	'.zyro.com',
	'.zyro.space',
	'.hostinger.io',
	'.hostinger.dev',
];

export const INTERNAL_SITE_IDS = new Set([
	'm6L2r0apGbF0JgPq',
	'dOqZN5rWK1tx3Mo5',
	'YyvD2p00MjtRqL8p',
	'm6L2r6gBKjtjKWlE',
	'mp84nGw8VqTXQB0n',
	'YBgjpMWQlJfGP61W',
]);
